import { addScript } from './utils/lazyLoadScript';

const initTrustpilot = () => {
  // load the external script
  const tpUrl = 'https:///widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
  addScript(tpUrl);
};

export default initTrustpilot;
